import { fetch } from '@/shared/fetch';
import { ConsultationTypeEnum } from '@/shared/enums';
import { SelectCaregiverDto } from '@/shared/interfaces';

export const fetchAvailableCaregivers = async (
    consultationType: ConsultationTypeEnum,
): Promise<SelectCaregiverDto[]> => {
    const result = await fetch<SelectCaregiverDto[] | null>(
        `/api/consultations/available-caregivers/${consultationType}`,
    );

    return result ?? [];
};
